// Copyright (c) 2021 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import React from 'react';
import Reping from './reping';

function RepingPage () {

    return (
        <AuthenticatedPage className="atp-page reping-page">
            <Reping />
        </AuthenticatedPage>
    );

}
RepingPage.displayNAme = 'RepingPage';

export default RepingPage;
